import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import KPMonthYearPicker from "../../../components/KPMonthYearPicker";
import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";

import { uploadMultiFile } from "../../../reducer/file/action";
import { insertStudentGuidance, updateStudentGuidance } from "../../../reducer/studentGuidance/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";

import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";

function StudentGuidanceInsertModal(props) {
  const { inserting, setInserting } = props;

  const dispatch = useDispatch();
  const [values, setValues] = useState({
    purposeId: 5,
    workType: "faculty_level_award",
    implementationTime: new Date(),
  });
  const [detail, setDetail] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [timeResearchYear, setTimeResearchYear] = useState(0);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [helperText, setHelperText] = useState(false);

  const profileDetail = useSelector((state) => select(state, "profileReducer", "detail"));

  // Tự gán bản thân vào danh sách thành viên
  React.useEffect(() => {
    if (props.profile?.id && profileList.length === 0) {
      setProfileList([
        {
          profileId: props.profile.id,
          roleInGuidance: "main",
          statusInProject: "K",
          isInternal: true,
          externalName: "",
        },
      ]);
    }
  }, [inserting, props.profile?.id]);

  React.useEffect(() => {
    if (values?.workType) setHelperText(false);
  }, [values?.workType]);

  React.useEffect(() => {
    if (!inserting) {
      setNewFiles([]);
    }
  }, [inserting]);

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else setValues({ ...values, [name]: value });
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInGuidance: "member",
      statusInProject: "K",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const insertStudentGuidance = async (uploadedUrls) => {
    let result = await props
      .insertStudentGuidance(props.profile?.id, {
        ...values,
        dashboardYear: values?.year,
        studentGuidanceProfile: profileList,
        fileUrl: uploadedUrls,
      })
      .then((response) => {
        if (response.success) {
          props.statisticUnaccepted({
            departmentId: 0,
            profileId: props.profile?.id,
          });
          if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
        }
        return response.success;
      });
  };

  const handleSubmit = async (e) => {
    if (!values?.workName || !values?.workType || !values?.implementationTime) {
      setHelperText(true);
      return;
    }

    let uploadedUrls = "";
    if (newFiles.length > 0) {
      const res = await dispatch(uploadMultiFile(profileDetail?.id, newFiles, "studentGuidance"));
      if (res.success) {
        uploadedUrls = (res.data || []).join("||");
      }
    }

    await insertStudentGuidance(uploadedUrls);

    setValues(null);
    setProfileList([]);
    setInserting(false);
  };

  const handleClose = () => {
    setValues(null);
    setProfileList([]);
    setNewFiles([]);
    setInserting(false);
  };

  // Filter timeResearchDetailList without year filtering
  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0) {
      // Get all timeResearchDetail from all years and filter by type
      let allDetails = [];
      props.timeResearchInformationList.forEach((yearData) => {
        if (yearData.timeResearchDetail) {
          allDetails = [...allDetails, ...yearData.timeResearchDetail];
        }
      });

      let list = allDetails.filter((e) => !e.allowedUpdateNum && e.type === "studentGuidance");
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList]);

  const profileListFromProps = [{ id: -1, name: "" }];
  props.profileList.forEach((e) => profileListFromProps.push(e));

  // const yearList = [];
  // props.timeResearchInformationList
  //   .sort((a, b) => b.year - a.year)
  //   .forEach((e) => {
  //     yearList.push(e.year);
  //   });

  const _note = useMemo(() => {
    let note = `Yêu cầu về minh chứng:
- Quyết định, thông báo kết quả
- Biên bản đánh giá hoặc giấy chứng nhận/giấy khen
- Các tài liệu liên quan khác (nếu có)

Ghi chú:
- Các tài liệu minh chứng phải có xác nhận của đơn vị
- Scan bản gốc hoặc bản sao có xác nhận`;
    return note;
  }, [values?.workType]);

  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth={false}
      open={inserting}
      onClose={() => setInserting(false)}
      disableBackdropClick
      PaperProps={{
        style: {
          width: "calc(100vw - 240px)",
          height: "100vh",
          maxWidth: "calc(100vw - 240px)",
          maxHeight: "100vh",
          margin: "0 0 0 240px",
        },
      }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 32px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography variant="h5" style={{ fontWeight: 600, marginRight: 24 }}>
          Thêm Hướng dẫn NCKHSV/Đạt giải NCKH và tương đương
        </Typography>
        <div style={{ display: "flex", gap: "12px" }}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => handleClose()}
            style={{
              padding: "8px 24px",
              fontSize: "15px",
              fontWeight: 500,
              borderWidth: 2,
            }}
          >
            Huỷ
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit()}
            // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
            disabled={false}
            style={{
              padding: "8px 24px",
              fontSize: "15px",
              fontWeight: 600,
              boxShadow: "0 2px 8px rgba(63, 81, 181, 0.3)",
            }}
          >
            Xác nhận
          </Button>
        </div>
      </DialogTitle>
      <DialogContent style={{ flex: 1, overflow: "hidden", display: "flex", padding: 0 }}>
        <div
          style={{
            width: "60%",
            padding: "16px 24px",
            overflowY: "auto",
            borderRight: "1px solid #e0e0e0",
          }}
        >
          <Grid container justifyContent="flex-start" spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Tên công trình"
                variant="outlined"
                required
                value={values?.workName?.toString() || ""}
                error={helperText && !values?.workName}
                helperText={helperText && !values?.workName ? "Vui lòng nhập tên công trình" : ""}
                onChange={(event) => handleChangeForm("workName", event.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" size="small" error={helperText && !values?.workType}>
                <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Loại công trình</InputLabel>
                <Select
                  native
                  fullWidth
                  required
                  value={values?.workType || ""}
                  onChange={(event) => handleChangeForm("workType", event.target.value)}
                >
                  <option value="faculty_level_award">Hướng dẫn đề tài sinh viên NCKH được giải cấp khoa/viện</option>
                  <option value="faculty_level_no_award">
                    Hướng dẫn đề tài sinh viên NCKH không đạt giải cấp khoa/viện
                  </option>
                  <option value="university_level_award">
                    Hướng dẫn đề tài sinh viên NCKH, vận động viên (đối với GV BM GDTC) đạt giải cấp trường
                  </option>
                  <option value="ministry_level_award">
                    Hướng dẫn sinh viên NCKH, vận động viên (đối với GV BM GDTC) đạt giải cấp Bộ, và tương đương
                  </option>
                  <option value="research_sports_award">
                    Tham gia và Đạt giải NCKH từ cấp bộ trở lên và giải thể thao (đối với GVBM GDTC) từ cấp Trường trở
                    lên
                  </option>
                </Select>
                {helperText && !values?.workType && <FormHelperText>Không được bỏ trống</FormHelperText>}
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Đạt giải</InputLabel>
                <Select
                  native
                  fullWidth
                  value={values?.awardLevel || ""}
                  onChange={(event) => handleChangeForm("awardLevel", event.target.value)}
                >
                  <option value="">-- Chọn giải thưởng --</option>
                  <option value="first_prize">Giải nhất</option>
                  <option value="second_prize">Giải nhì</option>
                  <option value="third_prize">Giải ba</option>
                  <option value="encouragement_prize">Giải khuyến khích</option>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <KPMonthYearPicker
                fullWidth
                label="Thời gian thực hiện"
                required
                value={values?.implementationTime || "01/01/2025"}
                setValue={(newValue) => {
                  const parts = newValue.split("/");
                  if (parts.length === 3) {
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10);
                    const year = parseInt(parts[2], 10);
                    const date = new Date(year, month - 1, day, 12, 0, 0);
                    handleChangeForm("implementationTime", date);
                  }
                }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Năm học"
                variant="outlined"
                value={values?.academicYear || ""}
                onChange={(event) => handleChangeForm("academicYear", event.target.value)}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Giải thưởng (nếu có)"
                variant="outlined"
                value={values?.award || ""}
                onChange={(event) => handleChangeForm("award", event.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Tóm tắt"
                variant="outlined"
                value={values?.summary || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("summary", event.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Kết quả khoa đánh giá"
                variant="outlined"
                value={values?.facultyEvaluation || ""}
                multiline
                rows={2}
                onChange={(event) => handleChangeForm("facultyEvaluation", event.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Kết quả trường đánh giá"
                variant="outlined"
                value={values?.universityEvaluation || ""}
                multiline
                rows={2}
                onChange={(event) => handleChangeForm("universityEvaluation", event.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Mục đích
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="purpose-label"
                  value={values?.purposeId ?? "none"}
                  onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                >
                  {props.purposes.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.description}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* {values?.purposeId === 5 && (
              <>
                <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => setTimeResearchYear(parseInt(event.target.value))}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Nhiệm vụ tính giờ nghiên cứu"
                    variant="outlined"
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
                    error={false}
                  >
                    {timeResearchDetailList.length > 0 ? (
                      timeResearchDetailList?.map((e) => (
                        <MenuItem key={e.code} value={e.code}>{e.description}</MenuItem>
                      ))
                    ) : (
                      <MenuItem value={null} disabled>
                        Chưa có dữ liệu
                      </MenuItem>
                    )}
                  </TextField>
                </Grid>
              </>
            )} */}

            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2} style={{ marginBottom: 8 }}>
                  <Grid item xs={1}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>

                  {e.isInternal && (
                    <Grid item xs={5}>
                      <Autocomplete
                        disableClearable
                        options={props.profileList}
                        getOptionLabel={(option) => option.name}
                        value={
                          profileListFromProps?.find((profile) => profile.id === e.profileId) || profileListFromProps[0]
                        }
                        onChange={(event, profile) => {
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                        )}
                      />
                    </Grid>
                  )}

                  {!e.isInternal && (
                    <Grid item xs={5}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên thành viên"
                        value={e?.externalName || ""}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                      {helperText && e.externalName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}

                  {e.isInternal && (
                    <>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          disabled
                          variant="outlined"
                          label="Mã viên chức"
                          value={profileListFromProps?.find((profile) => profile.id === e.profileId)?.code || ""}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          disabled
                          variant="outlined"
                          label="Đơn vị"
                          value={
                            profileListFromProps?.find((profile) => profile.id === e.profileId)?.departmentProfile?.[0]
                              ?.department?.name || ""
                          }
                        />
                      </Grid>
                    </>
                  )}

                  <Grid item xs={3}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Vai trò được giao</InputLabel>
                      <Select
                        native
                        fullWidth
                        value={e?.roleInGuidance || "main"}
                        onChange={(event) => handleChangeProfileList(index, "roleInGuidance", event.target.value)}
                      >
                        <option value="main">Người hướng dẫn chính</option>
                        <option value="member">Người hướng dẫn phụ</option>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={2}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Trạng thái</InputLabel>
                      <Select
                        native
                        fullWidth
                        value={e?.statusInProject || "K"}
                        onChange={(event) => handleChangeProfileList(index, "statusInProject", event.target.value)}
                      >
                        <option value="NCS">Đang làm NCS</option>
                        <option value="CH">Đang học Cao học</option>
                        <option value="K">Khác</option>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>
          </Grid>
        </div>

        <div
          style={{
            width: "40%",
            padding: "16px 24px",
            overflowY: "auto",
            backgroundColor: "#fafafa",
          }}
        >
          <Typography variant="h6" style={{ marginBottom: 16 }}>
            Upload file minh chứng
          </Typography>
          <div
            style={{
              backgroundColor: "#ffebee",
              color: "#c62828",
              padding: "12px",
              marginBottom: 16,
              borderRadius: 4,
              whiteSpace: "pre-line",
            }}
          >
            {_note}
          </div>
          <MultiFileManager
            fileUrls={[]}
            setFileUrls={() => {}}
            newFiles={newFiles}
            setNewFiles={setNewFiles}
            disabled={false}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  profileList: select(state, "profileReducer", "list"),
  listById: select(state, "studentGuidanceReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
});

const mapDispatchToProps = (dispatch) => ({
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  insertStudentGuidance: (profileId, payload) => dispatch(insertStudentGuidance(profileId, payload)),
  updateStudentGuidance: (profileId, payload) => dispatch(updateStudentGuidance(profileId, payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(StudentGuidanceInsertModal));

